import {DestroyRef, inject, Injectable} from '@angular/core';
import { JwksValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { getAuthConfig } from '../../oauth/auth.config';
import { OAuthConstants } from '../../oauth/constant/oAuth.constants';
import { GtSessionStorageService } from './gt-session-storage.service';
import { LoginService } from './login.service';
import * as moment from 'moment';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';



@Injectable()
export class GtOAuthService {
  private destroyRef = inject(DestroyRef);
  constructor(private oAuthService: OAuthService,
    private cookieService: CookieService,
    private loginService: LoginService,
    private gtSessionService: GtSessionStorageService) {
  }

  public oAuthConfiguration() {
    // Get config at call time to ensure sessionStorage is populated
    const config = getAuthConfig();
    this.oAuthService.configure(config);
    this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
    this.oAuthService.loadDiscoveryDocumentAndTryLogin();
  }

  public initiateOAuthFlow() {
    const requestedHref = window.location.href;
    if(['change-password'].find(url => requestedHref.includes(url))){
      return;
    }
    const oAuthAccessToken = this.cookieService.get(OAuthConstants.ACCESS_TOKEN);
    const urlParams = new URLSearchParams(window.location.search);
    const targetUrl = urlParams.has('targetUrl') ? urlParams.get('targetUrl') : '';

    if (oAuthAccessToken) {
      this.loginService.removeTokenForGuidLogin(requestedHref);
      this.loginService.isActiveToken(oAuthAccessToken)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((active) => {
        if (!active && !requestedHref.includes(OAuthConstants.LOGOUT)) {
          this.gtSessionService.remove(OAuthConstants.ACCESS_TOKEN);
          this.cookieService.delete(OAuthConstants.ACCESS_TOKEN, '/', window.location.host);
          this.setTargetUrlForOnSuccessRedirect(targetUrl);
          this.oAuthService.initImplicitFlow();
          this.setLoginInitiateTime();
        }
      }, (error) => {
        console.log('error occurred while introspect access token ', error);
      });
    }
    if (this.initiateImplicitFlow(requestedHref)) {
      this.setTargetUrlForOnSuccessRedirect(targetUrl);
      this.oAuthService.initImplicitFlow();
      this.setLoginInitiateTime();
    }
  }

  public forceFullyInitiateOauthFlow(): void {
    this.oAuthService.initImplicitFlow();
  }

  private initiateImplicitFlow(requestedHref: string): boolean {
    const skippedURLs = [
      OAuthConstants.ACCESS_TOKEN,
      OAuthConstants.ID_TOKEN,
      OAuthConstants.LOGIN_CHALLENGE,
      OAuthConstants.CONSENT_CHALLENGE,
      OAuthConstants.LOGOUT,
      OAuthConstants.RESET_URL,
      OAuthConstants.INTROSPECT_ERROR,
      OAuthConstants.UNKNOWN_DOMAIN,
      OAuthConstants.MAINTENANCE_NOTICE,
      OAuthConstants.OPENID_ROUTE,
      OAuthConstants.DISABLE_NOTICE,
      OAuthConstants.MFA_URL
    ];
    return (!this.cookieService.get(OAuthConstants.ACCESS_TOKEN))
      && !skippedURLs.find(url => requestedHref.includes(url));

  }

  private setLoginInitiateTime() {
    this.gtSessionService.remove(OAuthConstants.LOGIN_INITIATE_TIME);
    this.gtSessionService.put(OAuthConstants.LOGIN_INITIATE_TIME, JSON.stringify(moment.now()));
  }

  private setTargetUrlForOnSuccessRedirect(targetUrl: string) {
    if (targetUrl) {
      this.gtSessionService.put(OAuthConstants.TARGET_URL, targetUrl.replace(/^\//g, ''));
    }
  }
}
